module.exports = __webpack_public_path__ + "img/card3.42a6ba60.jpg";